import Nav from './components/Nav';
import AnimateOnPageLinks from './components/AnimateOnPageLinks';

import ToggleSections from './components/ToggleSections';

import heroSwiper from './components/swiper/heroSwiper';

import CategorySwiper from './components/swiper/CategorySwiper';
import ProductGallery from './components/swiper/ProductGallery';
import ContactModule from './components/ContactModule';
import StickyHeader from './components/StickyHeader';
import vCard from './components/vCard';

heroSwiper.init();
// Initialise our components on jQuery.ready…

CategorySwiper.init();
jQuery(function ($) {
	vCard.init();
	AnimateOnPageLinks.init();
	Nav.init();
	Nav.initSideNav();
	ToggleSections.init();
	ProductGallery.init();
	ContactModule.init();
	StickyHeader.init();

	jQuery(document).on('click', '#read-more', function () {
		jQuery(this).next().toggle('fast');
	});
});
StickyHeader.init();

ContactModule.initStickyContact('#sidebar', '#contactmodule .inner');

jQuery(window).on('scroll', function () {
	StickyHeader.init();
});
/* jQuery(window).on('load', function () {
    StickyHeader.init();
 
});
jQuery(window).on('resize', function () {
    StickyHeader.init();
  
});
 */
